'use strict';

module.exports = function(location,callback) {
	if(process.env.APP_ENV === 'browser')
		require.ensure([], function (require) {
			callback(null, require('./component'))
		});
	else
		callback(null, require('./component'));
}



// WEBPACK FOOTER //
// resources/modules/components/popup/termcondition/resolver.js